<template>
    <Card :title="$t('labels.order_custom_fields_create')">
        <form @submit.prevent="create">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.name')" required>
                            <Input
                                v-model="name"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.type')">
                            <AppSelect
                                @update:model-value="type = $event"
                                :model-value="type.key"
                                :selected-value="type.value"
                                :options="customFieldsOptions"
                                option-key="key"
                                option-value="value"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.show_in_order')">
                            <AppSwitch v-model="showInOrder" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-12" v-if="type.key === CustomFieldTypes.SELECT">
                        <FormGroup :label="$t('labels.select_items')">
                            <Tags
                                v-model="selectItems"
                                @keydown.enter.prevent
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <AppButton color="indigo" type="submit">
                    <i class="icon-floppy-disk mr-2"></i>
                    {{ $t('buttons.create') }}
                </AppButton>
            </div>
        </form>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppSelect from "../../../../components/new/form/select/AppSelect.vue";
import Tags from "../../../../components/new/form/Tags.vue";
import AppSwitch from "../../../../components/new/form/switch/AppSwitch.vue";

import { CustomFieldTypes } from "../../../enums/CustomFieldTypesEnum";
import { httpClient } from "../../../../services/HttpClient";

export default {
    name: 'OrderCustomFieldsCreatePage',
    components: {
        Card, AppButton, FormGroup, Input, AppSelect,
        Tags, AppSwitch
    },
    data() {
        return {
            CustomFieldTypes,
            customFieldsOptions: [],
            type: {
                key: 'string',
                value: this.$t(`enum.custom_field.type.string`)
            },
            name: '',
            selectItems: '',
            showInOrder: false
        }
    },
    methods: {
        create() {
            let requestBody = {
                name: this.name,
                type: this.type.key,
                show_in_order: this.showInOrder
            }

            if (this.type.key === this.CustomFieldTypes.SELECT) {
                requestBody.select_items = this.selectItems.split(',').map(item => item.trim());
            }

            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`, requestBody)
                .then((response) => {
                    this.$router.push({ name: 'OrderCustomFieldsEditPage', params: { customFieldUuid: response.data.data.uuid } });
                })
        }
    },
    mounted() {
        this.customFieldsOptions = Object.entries(this.CustomFieldTypes).map(([key, value]) => ({
            key: value,
            value: this.$t(`enum.custom_field.type.${value}`)
        }));
    }
}
</script>